import React, { createContext, useContext, useState } from "react";

const ServerErrorContext = createContext();
let _setServerErrorVisible = () => {};

export const ServerErrorProvider = ({ children }) => {
  const [serverErrorVisible, setServerErrorVisible] = useState(false);

  // Expose this setter globally
  _setServerErrorVisible = setServerErrorVisible;

  return (
    <ServerErrorContext.Provider
      value={{ serverErrorVisible, setServerErrorVisible }}
    >
      {children}
    </ServerErrorContext.Provider>
  );
};

export const useServerError = () => useContext(ServerErrorContext);

// 🔥 This is the external setter you can import in utilities
export const triggerServerErrorModal = (isVisible) => {
  _setServerErrorVisible(isVisible);
};
